import { baseApi } from "configs/store-query";
import {
  GetEmailAddressUserIdentifierAvailabilityApiRequest,
  GetEmailAddressUserIdentifierAvailabilityApiResponse,
  UserIdentifierPrimaryTypeApiRequest,
  UserIdentifierPrimaryTypeApiResponse,
  UserIdentifierSelfApiRequest,
  UserIdentifierSelfApiResponse,
} from "apis/user/types/user-identifier-api";
import { USER_IDENTIFIER } from "constants/tags";

const BASE_PATH = "/user-identifiers";

export const userIdentifierApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getSelfUserIdentifier: build.query<
      UserIdentifierSelfApiResponse,
      UserIdentifierSelfApiRequest
    >({
      query: (config) => ({
        url: `${BASE_PATH}/self`,
        method: "GET",
        ...config,
      }),
      providesTags: [USER_IDENTIFIER],
    }),
    getPrimaryTypeUserIdentifier: build.query<
      UserIdentifierPrimaryTypeApiResponse,
      UserIdentifierPrimaryTypeApiRequest
    >({
      query: ({ path, ...config }) => ({
        url: `${BASE_PATH}/primary/${path.type}`,
        method: "GET",
        ...config,
      }),
      providesTags: [USER_IDENTIFIER],
    }),
    getUserIdentifierEmailAddressAvailability: build.query<
      GetEmailAddressUserIdentifierAvailabilityApiResponse,
      GetEmailAddressUserIdentifierAvailabilityApiRequest
    >({
      query: ({ path, ...config }) => ({
        url: `${BASE_PATH}/${path?.value}/email-address-availability`,
        method: "GET",
        ...config,
      }),
      providesTags: [USER_IDENTIFIER],
    }),
  }),
});
